import {
  formatMargin,
  formatUnitPrice,
  MINIMUM_MARGIN_WITHOUT_APPROVAL,
} from "services/api/pricing/consts";
import { PricingMeteredItem } from "services/api/pricing/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const METERED_ITEM_COLUMNS: Column[] = [
  {
    title: "Stavka",
    field: "name",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingMeteredItem) => (
      <div>
        <p className="text-slate-700">{row.name}</p>
        <p className="text-xs text-slate-400 font-mono">{row.code}</p>
      </div>
    ),
  },
  {
    title: "Prodajna",
    field: "price",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingMeteredItem) => (
      <span className="whitespace-nowrap text-slate-700">
        {formatUnitPrice.format(row.price)}
      </span>
    ),
  },
  {
    title: "Naš trošak",
    field: "cost",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingMeteredItem) => (
      <span className="whitespace-nowrap text-slate-500">
        {formatUnitPrice.format(row.cost)}
      </span>
    ),
  },
  {
    title: "Izmjereno",
    field: "measuredCost",
    type: ColumnTypes.custom,
    /*
      Ono što nas stavka STVARNO košta, iz zapisa potrošnje. Bez ovog stupca cjenik može
      godinama tvrditi trošak koji je odavno drugi, a marža i pragovi odobravanja bi se
      računali iz njega.

      Valuta se ispisuje jer mjerenje dolazi u dolarima, a cjenik je u eurima — pretvorbe
      nema, pa se brojevi ne smiju uspoređivati bez oznake.
    */
    render: (row: PricingMeteredItem) => {
      if (!row.measuredCost) {
        return <span className="text-slate-400">se ne mjeri</span>;
      }

      const { average, min, max, samples, currency } = row.measuredCost;

      return (
        <div className="whitespace-nowrap">
          <span className="font-semibold text-slate-700">
            {average.toFixed(4).replace(".", ",")} {currency}
          </span>
          <p className="text-xs text-slate-400">
            {min.toFixed(4).replace(".", ",")} – {max.toFixed(4).replace(".", ",")} · {samples}{" "}
            {samples === 1 ? "čitanje" : "čitanja"}
          </p>
        </div>
      );
    },
  },
  {
    title: "Marža",
    field: "margin",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingMeteredItem) => {
      // Ispod nabave je zabrana, tanka marža samo upozorenje — dvije različite poruke.
      if (row.isBelowCost) {
        return <Badge text="Ispod nabave" variant="danger" height="small" showDot />;
      }

      const isThin = row.margin < MINIMUM_MARGIN_WITHOUT_APPROVAL;

      return (
        <span
          className={
            isThin
              ? "font-semibold text-amber-600 whitespace-nowrap"
              : "font-semibold text-slate-700 whitespace-nowrap"
          }
        >
          {formatMargin(row.margin)}
        </span>
      );
    },
  },
];
